import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationsENUS from './locales/enUS/translations.json';
import translationsIT from './locales/it/translations.json';

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false
    },
    defaultNS: 'translations',
    resources: {
      'en-US': { 
        translations: translationsENUS
      },
      'it-IT': {
        translations: translationsIT
      }
    },
  });

export default i18n;